(function () {
  const API_URL = 'https://apps.gloross.com/zlatnaribka/GetGiftVaucher';

  function parseResponseBody(response) {
    return response.json();
  }

  function formatSuccessMessage(data, fallback) {
    const parts = [fallback];

    if (data.cardValue != null && data.cardValue !== '') {
      const value =
        typeof data.cardValue === 'number' ? data.cardValue.toFixed(2) : String(data.cardValue);
      parts.push(`Стойност: ${value} €`);
    }

    return parts.join(' ');
  }

  function isVoucherFound(data) {
    return data != null && typeof data === 'object' && data.result === true;
  }

  async function fetchGiftVoucher(cardNumber) {
    if (window.apiUtils && typeof window.apiUtils.getGiftVoucher === 'function') {
      return window.apiUtils.getGiftVoucher(cardNumber);
    }

    const response = await fetch(`${API_URL}?cardNumber=${encodeURIComponent(cardNumber)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await parseResponseBody(response);
    return { ok: response.ok, data };
  }

  class VoucherCheck extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.input = this.querySelector('[data-voucher-input]');
      this.button = this.querySelector('[data-voucher-submit]');
      this.result = this.querySelector('[data-voucher-result]');
      this.infoButton = this.querySelector('[data-voucher-info]');
      this.infoPanel = this.querySelector('[data-voucher-info-panel]');
      this.infoClose = this.querySelector('[data-voucher-info-close]');

      this.button.addEventListener('click', () => this.check());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.check();
        }
      });

      if (this.infoButton && this.infoPanel) {
        if (!this.infoPanel.dataset.portaled) {
          document.body.appendChild(this.infoPanel);
          this.infoPanel.dataset.portaled = 'true';
        }

        this.infoButton.addEventListener('click', () => this.openInfoPanel());
        this.infoClose?.addEventListener('click', () => this.closeInfoPanel());
        this.infoPanel.addEventListener('click', (event) => {
          if (event.target === this.infoPanel) this.closeInfoPanel();
        });
        this._onInfoKeydown = (event) => {
          if (event.key === 'Escape') this.closeInfoPanel();
        };
      }
    }

    openInfoPanel() {
      if (!this.infoPanel) return;
      this.infoPanel.hidden = false;
      this.infoButton?.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this._onInfoKeydown);
      document.body.style.overflow = 'hidden';
      this.infoClose?.focus();
    }

    closeInfoPanel() {
      if (!this.infoPanel) return;
      this.infoPanel.hidden = true;
      this.infoButton?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this._onInfoKeydown);
      document.body.style.overflow = '';
      this.infoButton?.focus();
    }

    getMessage(name) {
      return this.dataset[name] || '';
    }

    setResult(text, type) {
      this.result.textContent = text;
      this.result.hidden = false;
      this.result.classList.remove(
        'voucher-check__result--success',
        'voucher-check__result--error',
        'voucher-check__result--loading'
      );
      if (type) this.result.classList.add(`voucher-check__result--${type}`);
    }

    clearResult() {
      this.result.hidden = true;
      this.result.textContent = '';
      this.result.classList.remove(
        'voucher-check__result--success',
        'voucher-check__result--error',
        'voucher-check__result--loading'
      );
    }

    setLoading(isLoading) {
      this.button.disabled = isLoading;
      this.input.disabled = isLoading;
      if (isLoading) {
        this.setResult(this.getMessage('messageLoading'), 'loading');
      }
    }

    async check() {
      const code = (this.input.value || '').trim();
      if (!code) {
        this.setResult(this.getMessage('messageEmpty'), 'error');
        return;
      }

      this.setLoading(true);

      try {
        const { data } = await fetchGiftVoucher(code);

        if (isVoucherFound(data)) {
          const text = formatSuccessMessage(data, this.getMessage('messageSuccess'));
          this.setResult(text, 'success');
        } else {
          this.setResult(this.getMessage('messageError'), 'error');
        }
      } catch {
        this.setResult(this.getMessage('messageNetwork'), 'error');
      } finally {
        this.button.disabled = false;
        this.input.disabled = false;
      }
    }
  }

  if (!customElements.get('voucher-check')) {
    customElements.define('voucher-check', VoucherCheck);
  }
})();
